import { Component, Inject } from "@angular/core";
import { Subscription } from "rxjs";
import { MdSnackBar, MdDialogRef, MD_DIALOG_DATA } from "@angular/material";
import "rxjs/Rx";
import { ProductReleaseService } from "../../services/ProductReleaseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import swal from "sweetalert2";
import { NotificationService } from "../../services/NotificationService";
import { IPushNotificationHistoryDTO, ProductsWithPushNotification } from "../../interfaces/PushNotificationHistory";
@Component({
  selector: "my-page-layout-revert-release",
  styles: [],
  template: require('./revertrelease.component.html'),
})
export class PageLayoutRevertReleaseComponent {
  private sub: Subscription;
  ProductReleaseId: number;
  ProductId: number;
  ParentProductId: number;
  ProductReleaseNo: string;
  ProductName: string;
  SubProductName: string;
  ProductCode:number;
  Title: string;
  TitleDescription: string;
  IsSTPPerformed: boolean = false;
  IsPushNotificationChecked: boolean = true;
  pushNotificationHistoryDTO: IPushNotificationHistoryDTO = { Title: "", Body: "", ProductReleaseId: 0, ProductId: 0, ParentProductId: 0 ,CreatedBy:0}
  pushNotificationMessage: any;
  ChangeLogData = "\nChange Logs:";
  commentForRelease: string;

  constructor(
    public dialogRef: MdDialogRef<PageLayoutRevertReleaseComponent>,
    public snackBar: MdSnackBar,
    private appLoaderService: AppLoaderService,
    private productRelaseService: ProductReleaseService,
    private notificationService: NotificationService,

    @Inject(MD_DIALOG_DATA) public data: any
  ) {
    document.body.style.overflow="hidden";
    this.ProductReleaseId = this.data.ProductReleaseId;
    this.ProductReleaseNo = this.data.ProductReleaseNo;
    this.ProductId = this.data.ProductId;
    this.ParentProductId = this.data.ParentProductId;
    this.IsSTPPerformed = this.data.IsSTPPerformed;
    this.ProductName = this.data.ProductName;
    this.SubProductName = this.data.SubProductName;
    this.ProductCode=this.data.ProductCode;

    if (this.data.Status == 3) {
      this.Title = "Activate Release";
      this.TitleDescription =
        "Are you sure want to Activate #" + this.ProductReleaseNo + " Release ?";
    } else if (this.data.Status == 2) {
      this.Title = "Approve Release";
      this.TitleDescription =
        "Are you sure want to Approve build #" + this.ProductReleaseNo + "?";
    } else if (this.data.Status == -1) {
      this.Title = "Reject Release";
      this.TitleDescription =
        "Are you sure want to reject build #" +
        this.ProductReleaseNo +
        "? Once you reject the build it will be deleted permanently!";
    } else if (this.data.Status == 1) {
      this.Title = "STP";
      this.TitleDescription =
        "Are you sure want to Start STP for build #" +
        this.ProductReleaseNo +
        "?";
    }
  }
  ActiveRelease() {
    this.appLoaderService.open();
    let model = {
      ProductReleaseId: this.ProductReleaseId,
      ProductId: Number(this.ProductId),
      PrductReleaseNo: this.ProductReleaseNo,
      UpdatedBy: Number(localStorage.getItem("userid")),
      CommentDesc: this.commentForRelease
    };

    this.productRelaseService.ActiveRelease(model).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          //if the release is added to the active releases in the database then send push notification if check box is checked
          if (this.checkIsValidProductForNotification() && this.IsPushNotificationChecked) {
            this.SendPushNotification()
          }
          this.appLoaderService.close();
          this.snackBar.open("Active Release Successfully", "", {
            duration: 2000,
          });
        } else {
          this.appLoaderService.close();
          this.snackBar.open(data.Error, "", {
            duration: 2000,
          });
        }
        document.body.style.overflow="auto";
        this.dialogRef.close(true);
      },
      (_error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
        this.appLoaderService.close();
      }
    );
  }
  checkIsValidProductForNotification() {
    let productCode = this.ProductCode;
    if (productCode in ProductsWithPushNotification) {
      return true;
    }
    return false;
  }
  SendPushNotification() {
    this.productRelaseService.getChangeLogDetails(this.ProductReleaseId).subscribe((data) => {
      let allChangeLog="";
      if (!data.IsError && !data.DataObject != null) {
        let counter = 1;
        for (let log of data.DataObject) {
          allChangeLog += '\n' + counter + '. ' + log.ChangeLog;
          counter++;
        }
        if(allChangeLog.length>150){
          this.ChangeLogData=allChangeLog.substring(0,150)+"...";
        }
        else{
          this.ChangeLogData=allChangeLog;
        }
        this.ChangeLogData+='\n\n"To view detailed change logs visit products page"'
      }
      else {
        allChangeLog= null
      }
      let message = {
        Title: this.ProductName + " updates available",
        Body: this.SubProductName + " Version " + this.ProductReleaseNo + " released" + this.ChangeLogData,
      }
      this.notificationService.sendNotificationMessageForAndroid(message).subscribe()
      this.notificationService.sendNotificationMessageForApple(message).subscribe()
      this.pushNotificationMessage = message
      this.pushNotificationHistoryDTO.Body = this.pushNotificationMessage.Body;
      this.pushNotificationHistoryDTO.Title = this.pushNotificationMessage.Title;
      this.pushNotificationHistoryDTO.ProductId = this.ProductId;
      this.pushNotificationHistoryDTO.ParentProductId=this.ParentProductId;
      this.pushNotificationHistoryDTO.ProductReleaseId = this.ProductReleaseId;
      this.pushNotificationHistoryDTO.CreatedBy=Number(localStorage.getItem("userid"))
      this.notificationService.addNotificationHistory(this.pushNotificationHistoryDTO).subscribe((data) => { //storing push notification history
        if (!data.IsError && data.DataObject != null) {
          this.appLoaderService.close();
          this.snackBar.open("Push notification sent successfully!", "", {
            duration: 2000
          })
        }
      });
    })
  }
  ApproveRelease() {
    this.appLoaderService.open();
    let model = {
      ProductReleaseId: this.ProductReleaseId,
      IsApproved: true,
      UpdatedBy: Number(localStorage.getItem("userid")),
      IsSTPPerformed: this.IsSTPPerformed,
      CommentDesc: this.commentForRelease
    };

    this.productRelaseService.ApproveRelease(model).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.appLoaderService.close();
          this.snackBar.open("Approve Release Successfully", "", {
            duration: 2000,
          });
        } else {
          this.appLoaderService.close();
          this.snackBar.open(data.Error, "", {
            duration: 2000,
          });
        }
        document.body.style.overflow="auto";
        this.dialogRef.close(true);
      },
      (_error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
        this.appLoaderService.close();
      }
    );
  }

  RejectRelease() {
    this.appLoaderService.open();
    let model = {
      ProductReleaseId: this.ProductReleaseId,
      IsApproved: true,
      UpdatedBy: Number(localStorage.getItem("userid")),
      CommentDesc: this.commentForRelease
    };

    this.productRelaseService.RejectRelease(model).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.appLoaderService.close();
          this.snackBar.open("Delete Release Successfully", "", {
            duration: 2000,
          });
        } else {
          this.appLoaderService.close();
          this.snackBar.open(data.Error, "", {
            duration: 2000,
          });
        }
        document.body.style.overflow="auto";
        this.dialogRef.close(true);
      },
      (_error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
        this.appLoaderService.close();
      }
    );
  }
  STPStart(showLoadder: boolean = true, ISRequestSTP = false) {
    if (showLoadder == true) this.appLoaderService.open();

    let model = {
      ProductReleaseId: this.ProductReleaseId,
      IsApproved: true,
      UpdatedBy: Number(localStorage.getItem("userid")),
      CommentDesc: this.commentForRelease
    };

    this.productRelaseService.STPStart(model).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.appLoaderService.close();
          this.snackBar.open("STP Started", "", {
            duration: 2000,
          });
        } else {
          this.appLoaderService.close();
          this.snackBar.open(data.Error, "", {
            duration: 2000,
          });
        }

        let result = {
          "result": true,
          "ISRequestSTP": ISRequestSTP 
        }
        document.body.style.overflow="auto";
        this.dialogRef.close(result);
      },
      (_error) => {
        document.body.style.overflow="auto";
        this.dialogRef.close(false);
        this.appLoaderService.close();
      }
    );
  }

  checkValue(result: boolean) {
    this.IsSTPPerformed = result;
  }
  checkValueForPushNotification(result: boolean) {
    this.IsPushNotificationChecked = result;
  }

  onSubmit(): void {
    if (this.data.Status == 3) {
      if (this.IsSTPPerformed == false) {
        swal
          .fire({
            title: "<strong>Releasing Product without STP</strong>",
            icon: "info",
            html: `
        <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>
        <b>Please confirm your action:</b>
        <ul style="text-align: left;">
        <li style="margin-top:10px;"><b>Accept:</b> Proceed with releasing this product without STP.</li>
        <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>
        <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>
        </ul>
        `,
            showCloseButton: true,
            showCancelButton: true,
            showDenyButton: true,
            focusConfirm: false,
            confirmButtonText: `Accept`,
            confirmButtonAriaLabel: "Accept",
            cancelButtonText: `Cancel`,
            cancelButtonAriaLabel: "Cancel",
            denyButtonText: `Request STP`,
            denyButtonAriaLabel: "Request STP",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.ActiveRelease();
            } else if (result.isDismissed) {
              document.body.style.overflow="auto";
              this.dialogRef.close(false);
            } else if (result.isDenied) {
              this.appLoaderService.open();
              this.productRelaseService
                .getReleaseByProductId(this.ProductId)
                .subscribe(
                  (data) => {
                    let IsAllowReleae: boolean = true;
                    if (!data.IsError && data.DataObject != null) {
                      
                      let releaseData = data.DataObject;
                      releaseData.forEach((element) => {
                        const customers = element.Customers ? element.Customers.map((c:any, index: number) => `${index+1}. ${c.Name}`) : [];
                        const toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                        element.CustomerTooltip = toolip;
                        if (
                          (element.Status == 0 || element.Status == 1) &&
                          element.IsDeleted == false
                        ) {
                          IsAllowReleae = false;
                        }
                      });
                      if (IsAllowReleae == true) {
                        this.STPStart(false, true);
                      } else {
                        this.appLoaderService.close();
                        swal
                          .fire({
                            title: "<strong>Unable To Process Request</strong>",
                            icon: "info",
                            html: `<P>You can't request STP because there is already one pending release in queue</P>`,
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: "Ok",
                          })
                          .then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              this.onSubmit();
                            }
                          });
                      }
                    } else {
                      this.appLoaderService.close();
                    }
                  },
                  (error) => {
                    this.appLoaderService.close();
                  }
                );
            }
          });
      } else {
        this.ActiveRelease();
      }
    } else if (this.data.Status == 2) {
      if (this.IsSTPPerformed == false) {
        swal
          .fire({
            title: "<strong>Skipping the Software Test Plan (STP)</strong>",
            icon: "info",
            html: `
        <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>
        `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: `Accept`,
            confirmButtonAriaLabel: "Accept",
            cancelButtonText: `Cancel`,
            cancelButtonAriaLabel: "Cancel",
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.ApproveRelease();
            } else if (result.isDismissed) {
              document.body.style.overflow="auto";
              this.dialogRef.close(false);
            }
          });
      } else {
        this.ApproveRelease();
      }
    } else if (this.data.Status == -1) this.RejectRelease();
    else if (this.data.Status == 1) this.STPStart();
  }

  onCancel(): void {
    document.body.style.overflow="auto";
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/Revert-Release/revertrelease.component.ts